<template>
    <search-group
        title="查询项目"
        @search="findData"
        @clear="clearValue">
        <Row
            :gutter="16"
            class="mb16" >
            <Col span="5">
                <Select
                    v-model="search.cityName"
                    placeholder="城市"
                    filterable>
                    <Option value="">请选择</Option>
                    <Option v-for="(item,index) in info.citys" :key="index" v-if="item" :value="item">{{item}}</Option>
                </Select>
            </Col>
            <Col span="5">
                <Select
                    v-model="search.source"
                    placeholder="来源渠道">
                    <Option value="">请选择</Option>
                    <Option v-for="(item,index) in info.channel" :key="index" :value="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="5">
              <Select
                placeholder="跟进人"
                v-model="search.currentHandler">
                <Option value="">请选择</Option>
                <Option v-for="(item,index) in info.handlePerson" :key="index" :value="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="5">
                <Select
                    placeholder="商机状态"
                    v-model="search.handleStatus">
                    <Option value="">请选择</Option>
                    <Option v-for="(item,index) in info.status" :key="index" :value="item.value">{{item.text}}</Option>
                </Select>
            </Col>
        </Row>
        <Row :gutter="16">
            <Col span="10">
              <DatePicker
                type="daterange"
                placeholder="创建时间"
                style="width:100%"
                format="yyyy-MM-dd"
                :value="search.createTime"
                @on-change="changeDate"></DatePicker>
            </Col>
            <Col span="5">
              <Select
                v-model="search.propertyType"
                placeholder="物业类型">
                <Option value="">请选择</Option>
                <Option v-for="(item,index) in info.propertyType" :key="index" :value="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="5">
                <Input
                    v-model="search.condition"
                    placeholder="搜索：姓名、电话"
                    @keyup.enter.native="findData"></Input>
            </Col>
        </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">
import SearchGroup from 'components/SearchGroup/index';
import { getInfo } from '@/api/ownerShip';

export default {
    data () {
        return {
            search:{
                cityName:null,
                source:null,
                createTime:null,
                handleStatus:null,
                currentHandler:null,
                condition:null,
                startTime:null,
                endTime:null,
                propertyType:null,
                page:1,
                limit:10,
            },
            info:{
                citys:[],
                channel:[],
                status:[],
                handlePerson:[],
                propertyType:[]
            }
        }
    },
    created () {
        this.init();
    },
    components: {
        SearchGroup
    },
    methods: {
        init(){
            getInfo().then(res => {
                console.log(res);
                this.info = res.data;
            })
        },
        findData() {
            this.$emit('findData',{...this.search,createTime:null})
        },
        clearValue(){
            Object.keys(this.search).forEach(item => {
                if(item !=='page'&&item !== 'limit'){
                    this.search[item]=null;
                }
            })
            console.log(this.search);
            this.$emit('clear',this.search);
        },
        changeDate(createTime) {
            console.log(createTime);
            this.search.createTime = createTime;
            this.search.startTime = createTime[0];
            this.search.endTime = createTime[1];
        }
    }
}
</script>
